import { useSelector } from 'react-redux';

import type { Layout } from '@/domains/productDiscovery/Listings/pages/Category/Category.model';

import { selectLayout } from '../selectors/layout';

export const useLayout = (): Layout => useSelector(selectLayout) || 'technical';
